// extracted by mini-css-extract-plugin
module.exports = {"moreStoriesBtnWrap":"YJxNP","col_3":"VdeHw","col":"tBPdd"};